"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInvoicingEntityToProject = exports.createInvoicingEntityLegalEntity = exports.updateInvoicingEntityLegalEntity = exports.deleteInvoicingEntityLegalEntity = exports.getInvoicingEntityLegalEntities = exports.getInvoicingEntityByName = exports.getInvoicingRegion = exports.get = exports.typeahead = exports.search = exports.deleteInvoicingEntity = exports.update = exports.create = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var base = '/api/invoicing-entity';
function create(invoicingEntityFormData) {
    var invoicingEntityData = invoicingEntityFormData;
    return api_1.default.post(base, invoicingEntityData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
// Update invoice entity
function update(oldInvoicingEntityData, invoicingEntityFormData) {
    var invoicingEntityData = invoicingEntityFormData;
    return api_1.default
        .put(base + '/' + oldInvoicingEntityData.id, invoicingEntityData)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.update = update;
function deleteInvoicingEntity(invoicingEntityId) {
    return api_1.default
        .delete(base + '/' + invoicingEntityId)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.deleteInvoicingEntity = deleteInvoicingEntity;
function search(query) {
    return api_1.default
        .post(base + '/search', query)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.search = search;
function typeahead(q, parentAccountId) {
    var queryParams = query_string_1.default.stringify({ q: q, parentAccountId: parentAccountId });
    return api_1.default
        .get(base + '/typeahead?' + queryParams)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.typeahead = typeahead;
function get(invoicingEntityId) {
    return api_1.default.get("".concat(base, "/").concat(invoicingEntityId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.get = get;
function getInvoicingRegion(invoicingRegionId) {
    return api_1.default
        .get('/api/invoicing-region/' + invoicingRegionId)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getInvoicingRegion = getInvoicingRegion;
function getInvoicingEntityByName(invoicingEntityName) {
    return api_1.default.get("".concat(base, "/name/").concat(invoicingEntityName)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getInvoicingEntityByName = getInvoicingEntityByName;
function getInvoicingEntityLegalEntities(invoicingEntityId) {
    return api_1.default.get("".concat(base, "/").concat(invoicingEntityId, "/invoicing-entity-legal-entities")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getInvoicingEntityLegalEntities = getInvoicingEntityLegalEntities;
function deleteInvoicingEntityLegalEntity(invoicingEntityId) {
    return api_1.default
        .delete("".concat(base, "/").concat(invoicingEntityId, "/delete-invoicing-entity-legal-entity"))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.deleteInvoicingEntityLegalEntity = deleteInvoicingEntityLegalEntity;
function updateInvoicingEntityLegalEntity(invoicingEntityId, data) {
    return api_1.default
        .put("".concat(base, "/").concat(invoicingEntityId, "/update-invoicing-entity-legal-entity"), data)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateInvoicingEntityLegalEntity = updateInvoicingEntityLegalEntity;
function createInvoicingEntityLegalEntity(data) {
    return api_1.default.post("".concat(base, "/create-invoicing-entity-legal-entity"), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.createInvoicingEntityLegalEntity = createInvoicingEntityLegalEntity;
function addInvoicingEntityToProject(invoicingEntityId, projectId) {
    return api_1.default
        .get("".concat(base, "/").concat(invoicingEntityId, "/add-invoicing-entity-to-project/").concat(projectId))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.addInvoicingEntityToProject = addInvoicingEntityToProject;
var api = {
    create: create,
    update: update,
    deleteInvoicingEntity: deleteInvoicingEntity,
    search: search,
    typeahead: typeahead,
    get: get,
    getInvoicingRegion: getInvoicingRegion,
    getInvoicingEntityByName: getInvoicingEntityByName,
    getInvoicingEntityLegalEntities: getInvoicingEntityLegalEntities,
    deleteInvoicingEntityLegalEntity: deleteInvoicingEntityLegalEntity,
    updateInvoicingEntityLegalEntity: updateInvoicingEntityLegalEntity,
    createInvoicingEntityLegalEntity: createInvoicingEntityLegalEntity,
    addInvoicingEntityToProject: addInvoicingEntityToProject,
};
exports.default = api;
